import { Heart } from "lucide-react";
import { cn } from "@/lib/utils";

const FavoriteButton = ({
  isFavorite,
  onClick,
  className,
}: {
  isFavorite: boolean;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
}) => (
  <button
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }}
    className={cn(
      "p-1.5 rounded-lg transition-all",
      isFavorite
        ? "text-red-400 bg-red-400/10 hover:bg-red-400/20"
        : "text-muted-foreground hover:text-red-400 hover:bg-red-400/10 opacity-0 group-hover:opacity-100",
      isFavorite && "opacity-100",
      className
    )}
    title={isFavorite ? "Remove bookmark" : "Bookmark this tool"}
  >
    <Heart className={cn("w-3.5 h-3.5", isFavorite && "fill-current")} />
  </button>
);

export default FavoriteButton;
